import csiHeading from "csi/heading/_base";
import StringRen from "csi/heading/String";
import locale from "csi/locale";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

function _format(value): string {
	return locale.resourceIfExists("SupplierRequestSubtype_" + value) || locale.type(value) || "";
}

const SubtypeNameRenderer = declare(StringRen, {
	// limit query operations to EQ/NE so the client can send full class names to the server to filter by (substrings won't work)
	queryOps: csiHeading.QUERY_OPS[xml.ATTR_ENUM],

	formatValue: _format,
	_toSortValue: _format,
	
});

export = SubtypeNameRenderer;